// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file AirSpaceBoundaryDTOList.proto (package AirSpaceBoundaryDTOList, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AirSpaceBoundaryDTO } from "./AirSpaceBoundaryDTO_pb";
import { file_AirSpaceBoundaryDTO } from "./AirSpaceBoundaryDTO_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file AirSpaceBoundaryDTOList.proto.
 */
export const file_AirSpaceBoundaryDTOList: GenFile = /*@__PURE__*/
  fileDesc("Ch1BaXJTcGFjZUJvdW5kYXJ5RFRPTGlzdC5wcm90bxIXQWlyU3BhY2VCb3VuZGFyeURUT0xpc3QiVQoXQWlyU3BhY2VCb3VuZGFyeURUT0xpc3QSOgoIZW50aXRpZXMYASADKAsyKC5BaXJTcGFjZUJvdW5kYXJ5RFRPLkFpclNwYWNlQm91bmRhcnlEVE9CTQotY29tLmdtdi5kZW1ldGVyLm5hdmFpZHMubW9kZWwucHJvdG8uZ2VuZXJhdGVkQhxBaXJTcGFjZUJvdW5kYXJ5RFRPTGlzdFByb3RvYgZwcm90bzM", [file_AirSpaceBoundaryDTO]);

/**
 * @generated from message AirSpaceBoundaryDTOList.AirSpaceBoundaryDTOList
 */
export type AirSpaceBoundaryDTOList = Message<"AirSpaceBoundaryDTOList.AirSpaceBoundaryDTOList"> & {
  /**
   * @generated from field: repeated AirSpaceBoundaryDTO.AirSpaceBoundaryDTO entities = 1;
   */
  entities: AirSpaceBoundaryDTO[];
};

/**
 * Describes the message AirSpaceBoundaryDTOList.AirSpaceBoundaryDTOList.
 * Use `create(AirSpaceBoundaryDTOListSchema)` to create a new message.
 */
export const AirSpaceBoundaryDTOListSchema: GenMessage<AirSpaceBoundaryDTOList> = /*@__PURE__*/
  messageDesc(file_AirSpaceBoundaryDTOList, 0);

